export default __webpack_public_path__ + "static/hala1080-abf1687c479379f59a14c57da25de264.mp4";